import type { GuardianTeenDetailResponse, GuardianTeenGigRequestResponse } from "../../../../types/guardianTypes";
import { formatDate as formatSharedDate } from "../../../../utils/DateUtils";
import { formatCityStateZip } from "../../../../utils/LocationUtils";

export const formatDate = (value: string | null): string => {
  return formatSharedDate(value);
};

export const buildTeenLocation = (teen: GuardianTeenDetailResponse) => {
  return formatCityStateZip(teen, "Location not set");
};

export const buildTeenLocationLines = (teen: GuardianTeenDetailResponse) => {
  return [formatCityStateZip(teen, "Location not set")];
};

export type TeenRequestFilter = "needsApproval" | "approved" | "declined" | "all";

const isApprovedRequest = (request: GuardianTeenGigRequestResponse) =>
  request.guardianApprovalDecision === "APPROVED"
  && request.requestStatus !== "GUARDIAN_PENDING"
  && request.requestStatus !== "GUARDIAN_REJECTED";

export const getTeenRequestFilterCounts = (requests: GuardianTeenGigRequestResponse[]) => ({
  needsApproval: requests.filter((request) => request.requestStatus === "GUARDIAN_PENDING").length,
  approved: requests.filter(isApprovedRequest).length,
  declined: requests.filter((request) => request.requestStatus === "GUARDIAN_REJECTED").length,
  all: requests.length,
});

export const filterTeenGigRequests = (
  requests: GuardianTeenGigRequestResponse[],
  filter: TeenRequestFilter,
) => {
  switch (filter) {
    case "needsApproval":
      return requests.filter((request) => request.requestStatus === "GUARDIAN_PENDING");
    case "approved":
      return requests.filter(isApprovedRequest);
    case "declined":
      return requests.filter((request) => request.requestStatus === "GUARDIAN_REJECTED");
    case "all":
      return requests;
  }
};
